module.exports = __webpack_public_path__ + "static/media/icon-success-white.024ef280.svg";